export default "__VITE_ASSET__BMeB8OEm__"